import React from 'react'
import styles from './MicrositeStatusBadge.module.css'
import { Circle, Clock, CheckCircle2, FileEdit } from 'lucide-react'

/**
 * MicrositeStatusBadge
 *
 * Generic colored status pill. Covers the draft/published/scheduled
 * pattern used on Custom Pages and Blog Posts, but is configurable
 * enough to reuse for any small status vocabulary via `toneMap`.
 *
 * Usage (default draft/published/scheduled):
 *   <MicrositeStatusBadge status={row.status} />
 *
 * Usage (custom vocabulary, e.g. build status):
 *   <MicrositeStatusBadge
 *     status={buildStatus}
 *     toneMap={{
 *       SUCCESS: { label: 'Live', tone: 'live', icon: CheckCircle2 },
 *       BUILDING: { label: 'Publishing…', tone: 'pending', icon: Clock },
 *       FAILED: { label: 'Failed', tone: 'failed', icon: Circle }
 *     }}
 *   />
 */
const DEFAULT_TONE_MAP = {
    draft: { label: 'Draft', tone: 'draft', icon: FileEdit },
    published: { label: 'Published', tone: 'live', icon: CheckCircle2 },
    scheduled: { label: 'Scheduled', tone: 'pending', icon: Clock }
}

const MicrositeStatusBadge = ({ status, toneMap = DEFAULT_TONE_MAP }) => {
    const meta = toneMap[status] || { label: status || 'Unknown', tone: 'neutral', icon: Circle }
    const Icon = meta.icon || Circle

    return (
        <span className={`${styles.badge} ${styles[`tone_${meta.tone}`]}`}>
            <Icon size={11} className={styles.icon} />
            {meta.label}
        </span>
    )
}

export default MicrositeStatusBadge